'use strict';

const SELECTORS = {
    element: '.js-prod-tile',
    compareCheckbox: '.js-tile-compare-checkbox'
};

var _skpTileCounter = 0;

/**
 * Override Skeepers star colors with the site's primary color CSS variable.
 * Also fixes clipPath ID collisions — Skeepers reuses the same IDs across all
 * widget instances, so after cart add a new widget's url(#id) references can
 * override the existing ones, making all stars appear fully filled.
 */
function overrideSkeepersStarColors() {
    var primaryColor = getComputedStyle(document.documentElement)
        .getPropertyValue('--color-primary').trim();

    if (!primaryColor) return;

    function processSkeepersStars(container) {
        var ratingContainers = container.querySelectorAll(
            '.cc-prod-tile__rating, .skeepers_product__stars, .js-prod-rating'
        );

        ratingContainers.forEach(function (ratingContainer) {
            ratingContainer.querySelectorAll('.stars__item svg').forEach(function (svg) {
                var clipPathEl = svg.querySelector('defs clipPath');
                if (clipPathEl) {
                    var newId = 'skp-clip-' + (++_skpTileCounter);
                    clipPathEl.setAttribute('id', newId);

                    svg.querySelectorAll('path[clip-path]').forEach(function (path) {
                        path.setAttribute('clip-path', 'url(#' + newId + ')');
                    });
                }

                svg.querySelectorAll('path').forEach(function (path) {
                    if (path.getAttribute('fill') !== 'none') {
                        path.setAttribute('fill', primaryColor);
                    }
                    if (path.getAttribute('stroke') && path.getAttribute('stroke') !== 'none') {
                        path.setAttribute('stroke', primaryColor);
                    }
                });
            });
        });
    }

    processSkeepersStars(document);

    var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
                if (node.nodeType === 1) {
                    processSkeepersStars(node);
                }
            });
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });
}

module.exports = function () {
    $(document).on('click', SELECTORS.element, function (e) {
        if ($(e.target).closest('a, button, input, select, textarea, label, [role="button"], [role="link"]').length) {
            return;
        }

        var productUrl = $(this).data('link');
        if (productUrl) {
            window.location.assign(productUrl);
        }
    });

    $(document).on('change', SELECTORS.compareCheckbox, function (e) {
        if (this.checked) {
            $(this).closest(SELECTORS.element).addClass('cc-hover');
        } else {
            $(this).closest(SELECTORS.element).removeClass('cc-hover');
        }
    });

    $('body').on('search:updateDom product:afterAttributeSelect', function () {
        $('[data-toggle="tooltip"]').tooltip({ html: true });
    });

    overrideSkeepersStarColors();
};